<template>
    <div class="wrapper"
         :class="[
			{ 'nav-open': $sidebar.showSidebar },
		  	{ rtl: $route.meta.rtlActive }
    	]">
		<notifications></notifications>
		<side-bar :active-color="sidebarBackground"
			:background-image="sidebarBackgroundImage"
			:data-background-color="sidebarBackgroundColor"
			titleRoute="Dashboard">
			<template slot="links">
				<sidebar-item :link="{ name: 'Accueil', icon: 'home', path: 'dashboard', route: 'Dashboard' }"></sidebar-item>
				<sidebar-item :link="{ name: 'Clients' }">
					<sidebar-item :link="{ name: 'Liste', icon: 'user', path: 'clients', route: 'Clients' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Sites', icon: 'stream', path: 'sites', route: 'Sites' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Contrats', icon: 'file-contract', path: 'contracts', route: 'Contracts' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Facturation', icon: 'euro-sign', path: '/admin/billing', route:'Billing Contracts' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Demandes', icon: 'phone', path: 'demands', route: 'Demands' }"></sidebar-item>
				</sidebar-item>
				<sidebar-item :link="{ name: 'Planning' }">
					<sidebar-item :link="{ name: 'Calendrier', icon: 'calendar', path: 'calendar', route: 'Calendar' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Gestion', icon: 'bars', path: 'planning_management', route: 'Planning Management' }"></sidebar-item>
				</sidebar-item>
				<sidebar-item :link="{ name: 'Interventions' }">
					<sidebar-item :link="{ name: 'Liste complète', icon: 'bars', path: 'interventions', route: 'Interventions'}"></sidebar-item>
					<sidebar-item :link="{ name: 'Types d\'interventions', icon: 'cube', path: 'intervention_types', route:'InterventionType' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Rapports', icon: 'file', path: 'intervention_reports', route:'InterventionReports' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Produits', icon: 'file-alt', path: 'products', route: 'Products' }"></sidebar-item>
				</sidebar-item>
				<sidebar-item :link="{ name: 'Dispositifs' }">
					<sidebar-item :link="{ name: 'Types', icon: 'cog', path: 'device_types', route: 'Device Types' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Fiches de suivi', icon: 'desktop', path: 'report_types', route: 'Report Types' }"></sidebar-item>
				</sidebar-item>
				<sidebar-item :link="{ name: 'Techniciens' }">
					<sidebar-item :link="{ name: 'Liste', icon: 'male', path: 'technicians', route: 'Technicians' }"></sidebar-item>
				</sidebar-item>
				<sidebar-item :link="{ name: 'Autres' }">
					<sidebar-item :link="{ name: 'Documents', icon: 'folder-open', path: 'documents', route: 'Documents' }"></sidebar-item>
					<sidebar-item :link="{ name: 'Statistiques', icon: 'chart-line', path: 'stats', route: 'Stats' }"></sidebar-item>
                </sidebar-item>
			</template>
		</side-bar>
		<div class="main-panel relative overflow-hidden">
			<top-navbar></top-navbar>
			<breadcrumbs></breadcrumbs>

			<div :class="{ content: !$route.meta.hideContent }"
				@click="toggleSidebar">
				<zoom-center-transition :duration="200" mode="out-in">
					<!-- your content here -->
					<router-view :key="$route.fullPath" />
				</zoom-center-transition>
			</div>
		</div>
	</div>
</template>
<script>
// Components
import TopNavbar from "./TopNavbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";

import Vuex from 'vuex';

export default {
    name: 'DashboardLayout',
	components: {
		TopNavbar,
		Breadcrumbs
	},
	data() {
		return {
			sidebarBackgroundColor: "black",
			sidebarBackground: "purple",
			sidebarBackgroundImage: process.env.VUE_APP_APP_BASE_URL + "/img/sidebar-2.jpg",
			sidebarMini: false,
			sidebarImg: false,
			image: process.env.VUE_APP_APP_BASE_URL + '/img/laravel-vue.svg',
			roles: [],
		};
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
		async getProfile() {
			await this.$store.dispatch("profile/me")
		},
	},
	created() {
		this.getProfile();
	},
    mounted() {
        document.title = 'Gaia - Administration'
    },
    computed: {
		...Vuex.mapState({
			me: state => state.profile.me
		})
	},
	watch: {
		me: {
			handler: function(val) {
				this.roles = val.roles.map(r => r.name)
				this.user = val.name
			},
			deep: true
		},
		sidebarMini() {
			this.minimizeSidebar();
		},
        'editSitePlan.show'(newVal) {
		    if(newVal) {
		        document.querySelector('.sidebar-image').classList.add('drawer-light-overlay')
            } else {
                document.querySelector('.sidebar-image').classList.remove('drawer-light-overlay')
            }
        },
	}
};
</script>
<style lang="scss">

</style>
